import jquery from 'jquery';
import get from 'lodash/get';

/*
    this intends to workaround https://github.com/facebook/react/issues/1159

    The bug exists because Safari doesn't trigger any event when data is added
    to an input via it's autofill tool.

    So this workaround stores the input "virtual-value" - which is the value
    react think it's in the input. And on "change" or "blur" events, it
    checks if the "virtual-value" is the same as the real value.

    If it's not, it triggers an "input" event into the input,
    updating react value.

    This works only for auto-completed fields.
    It doesn't fix auto-filled forms.

    Created to fix:
    https://github.com/SweetProcess/sweetprocess.com/issues/3048
 */

type EventWithAdditionalAttrs = Event & {
  simulated?: boolean;
};

const isSafari = () => {
  const safariNotificationObj = get(window, 'safari.pushNotification', {});
  return (
    safariNotificationObj.toString() === '[object SafariRemoteNotification]'
  );
};

const getInputSelectors = (types: string[]) =>
  types.map((type) => `input[type="${type}"]`).join(',');

const triggerInputEvent = (element) => {
  let event = new Event('input', {
    bubbles: true,
  }) as EventWithAdditionalAttrs;
  event.simulated = true;
  element.dispatchEvent(event);
};

const updateVirtualValue = (ev) =>
  jquery(ev.target).data('virtual-v', ev.target.value);

const compareAndFixVirtualValue = (ev) => {
  const $element = jquery(ev.target);

  if ($element.data('virtual-v') !== ev.target.value) {
    triggerInputEvent(ev.target);
  }
};

const updateBeforeSubmit = (ev) => {
  if (ev.which === 13) {
    triggerInputEvent(ev.target);
  }
};

const applyAutocompleteFix = (
  types: string[] = ['text', 'password', 'email'],
  evNamespace = 'autocomplete-fix'
) => {
  const inputSelector = getInputSelectors(types);
  const $body = jquery('body');

  const addNs = (event) => [event, evNamespace].join('.');

  $body.on('focus', inputSelector, (ev) => {
    updateVirtualValue(ev);
    jquery(ev.target)
      .on(addNs('input'), updateVirtualValue)
      .on(addNs('change'), compareAndFixVirtualValue)
      .on(addNs('blur'), compareAndFixVirtualValue)
      .on(addNs('keypress'), updateBeforeSubmit);
  });
  $body.on('blur', inputSelector, (ev) => {
    compareAndFixVirtualValue(ev);
    jquery(ev.target).off(addNs(''));
  });
};

export const loadSafariAutocompleteFix = (
  types?: string[],
  evNamespace?: string
): unknown => isSafari() && applyAutocompleteFix(types, evNamespace);
